const multiplier = 1024*1024
function byteToMB(byte){
    return (byte/multiplier).toFixed(2)
}

export default {byteToMB}